// Copyright (c) 2017 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const getColumnHeaders = () => [
    {
        className: 'description',
        id: 'DESCRIPTION'
    },
    {
        className: 'quantity',
        id: 'QUANTITY'
    },
    {
        className: 'amount',
        id: 'AMOUNT'
    },
    {
        className: 'adjustment-type',
        id: 'ADJUSTMENT_TYPE'
    },
    {
        className: 'value-of-adjustment',
        id: 'NEW_VALUE'
    }
];

const DebitOtherCreditPanelRowHeader = () =>
    <section className='debit-other-credit-panel-row-header'>
        {
            getColumnHeaders().map(column =>
                <span
                    className={column.className}
                    key={column.id}
                >
                    <FormattedMessage id={column.id}/>
                </span>
            )
        }
    </section>;

DebitOtherCreditPanelRowHeader.displayName = 'DebitOtherCreditPanelRowHeader';

export default DebitOtherCreditPanelRowHeader;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-other-credits-panel/debit-other-credit-panel-row-header.js